import React from "react";
import { Provider } from "react-redux";
import { store } from "./store";
import IndexPage from "../src/templates/index";
import AIInterview from "./components/AIInterview";
import "./App.css";

// Dev-/Test-Einstieg: ?aiInterview=<leadId> rendert das KI-Interview direkt
// (ohne Funnel-Durchlauf). Im echten Flow rendert OtpFlow das Interview
// inline nach der Verifizierung, vor der Danke-Seite.
const aiInterviewLeadId = new URLSearchParams(window.location.search).get(
  "aiInterview"
);

function App() {
  return (
    <Provider store={store}>
      {aiInterviewLeadId ? (
        <div style={{ maxWidth: 680, margin: "0 auto", padding: "32px 16px" }}>
          <AIInterview leadId={aiInterviewLeadId} />
        </div>
      ) : (
        <IndexPage />
      )}
    </Provider>
  );
}

export default App;
